﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Paises } from "../Paises";
import { Provincias } from "../Provincias/Provincias";


const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.PK, prompt: 'País' }),
        c_provincia_id: new EntityColumn<string>({ name: 'c_provincia_id', type: 'char', length: 20, flags: c.PK, prompt: 'Provincia' }),
        c_ciudad_id: new EntityColumn<string>({ name: 'c_ciudad_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Ciudad Id' }),
        vc_ciudad_nombre: new EntityColumn<string>({ name: 'vc_ciudad_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre Ciudad' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        ciud_brwStandard: { name: 'ciud_brwStandard', keyMappings: { c_ciudad_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Provincias(client, parentKeys)
        }
    }
)


export class CiudadesDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();


    constructor() {
        super('Ciudades');
    }
}